import { useCallback, useEffect, useMemo, useState } from 'react'
import { useRouter } from 'next/router'
import { stringifyUrl } from '@ucheba/utils/helpers/router'
import { useSelector } from 'react-redux'
import { clientProductsRequestsSelectors } from '@ucheba/store/client-products/requests'
import { ELoading } from '@ucheba/store/utils/response/types'
import { IProduct } from '@ucheba/store/client-products/tariffs/types'
import { EApplicationFormQuery } from '../AppliactionForm/types'
import { IUseSelectProductRequestApplication } from './types'

export const useSelectProductRequestApplication: IUseSelectProductRequestApplication = (
  props
) => {
  const { onPay } = props

  const router = useRouter()

  const clientProductsRequestsLoading = useSelector(
    clientProductsRequestsSelectors.loading
  )

  const isSendSuccess = useMemo(
    () => clientProductsRequestsLoading === ELoading.fulfilled,
    [clientProductsRequestsLoading]
  )

  const [productItems, setProductItems] = useState<null | IProduct>(null)

  const selectGroup = useCallback(
    (funnel, requestTarget, values, product, amoTag, id, eventsId): void => {
      setProductItems(product)
      router.push(
        stringifyUrl(
          router.asPath,
          {
            update: {
              [EApplicationFormQuery.application]: 'true',
              [EApplicationFormQuery.productId]:
                values?.[EApplicationFormQuery.productId],
              [EApplicationFormQuery.count]: values?.[EApplicationFormQuery.count],
              [EApplicationFormQuery.withPayment]:
                values?.[EApplicationFormQuery.withPayment],
              [EApplicationFormQuery.funnel]: funnel,
              [EApplicationFormQuery.requestTarget]: requestTarget,
              [EApplicationFormQuery.step]: 'start',
              [EApplicationFormQuery.isNotCode]:
                values?.[EApplicationFormQuery.isNotCode],
              [EApplicationFormQuery.amoTag]: amoTag,
              [EApplicationFormQuery.eventsId]: eventsId,
              [EApplicationFormQuery.subjectId]: id,
            },
          },
          undefined
        ),
        undefined,
        { shallow: true, scroll: false }
      )
    },
    [router]
  )

  useEffect(() => {
    if (onPay && isSendSuccess && productItems) {
      onPay(productItems)
    }
  }, [isSendSuccess, onPay, productItems])

  useEffect(() => {
    const { application } = router.query
    if (!application) {
      setProductItems(null)
    }
  }, [router.query])

  return {
    selectGroup,
  }
}
